import Mock from 'mockjs'
import url from '@mock/mockAPI.js'

export default {}
